import { Injectable } from '@angular/core';
import {
  AssetSpace,
  TextSetSpace,
} from 'src/app/core/lib-type-shims';
import { AssetSet } from '@brafton/assets-api';
import { IBase, IBaseHasParent, IBaseProject, MasterProject } from '@brafton/common-framework-library';
import { TextSet } from '@brafton/text-api-client';

@Injectable({ providedIn: 'root' })
export class testAssetAndTextsetService {
  constructor() {}

  public getAssetsFromSpace(space: IBaseProject, master?: MasterProject): AssetSpace[] {
    if (!space) return [];

    let assets: AssetSpace[] = [];

    if ((space as any).assets) {
      (space as any).assets.forEach((a: AssetSet) => {
        assets.push({ asset: a, space: space, master: master } as AssetSpace);
      });
    }

    if ((space as any)?.children) {
      (space as any).children.forEach((p: IBase) => {
        assets = assets.concat(this.getAssetsFromPhase(p, space, master));
      });
    }

    return assets;
  }

  public getAssetsFromAncestor(ancestor: IBase): AssetSpace[] {
    if (!ancestor) return [];

    let assets: AssetSpace[] = [];

    const allowedTypes = ['Project', 'StatementOfWork', 'Organization'];

    if ((ancestor as any).assets && allowedTypes.some((at) => ancestor.type.includes(at))) {
      (ancestor as any).assets
        .filter((a: AssetSet) => a.accessLevel.id !== 'System')
        .forEach((a: AssetSet) => {
          assets.push({ asset: a, space: undefined } as unknown as AssetSpace);
        });
    }

    if ((ancestor as unknown as IBaseHasParent).parent) {
      assets = assets.concat(this.getAssetsFromAncestor((ancestor as unknown as IBaseHasParent).parent));
    }

    return assets;
  }

  public getAssetsFromPhase(phase: IBase, space: IBaseProject, master?: MasterProject): AssetSpace[] {
    if (!phase) return [];

    if ((phase as any).assets && (phase as any).assets.length > 0) {
      return (phase as any).assets
        .filter((a: AssetSet) => a.accessLevel.id !== 'System')
        .map((a: AssetSet) => {
          return { asset: a, space: space, master: master, phase: phase } as AssetSpace;
        });
    }

    return [];
  }

  public getTextSetFromSpaceAndAncestors(space: IBaseProject, master?: MasterProject): TextSetSpace[] {
    if (!space) return [];

    const ancestorTextSets = this.getTextSetFromAncestor(space);
    const spaceTextSets = this.getTextSetFromSpace(space, master);

    let combinedTextSets = [...ancestorTextSets, ...spaceTextSets].filter(
      (value, index, self) => index === self.findIndex((t) => t.textSet.id === value.textSet.id),
    );

    return combinedTextSets;
  }

  public getTextSetFromSpace(space: IBaseProject, master?: MasterProject): TextSetSpace[] {
    if (!space) return [];

    let textSet: TextSetSpace[] = [];

    if ((space as any).texts) {
      (space as any).texts
        .filter((t: TextSet) => t.accessLevel!.id !== 'System')
        .forEach((a: TextSet) => {
          textSet.push({ textSet: a, space: space, master: master } as TextSetSpace);
        });
    }

    if ((space as any)?.children) {
      (space as any).children.forEach((p: IBase) => {
        textSet = textSet.concat(this.getTextSetFromPhase(p, space, master));
      });
    }

    return textSet;
  }

  public getTextSetFromAncestor(ancestor: IBase): TextSetSpace[] {
    if (!ancestor) return [];

    let textSets: TextSetSpace[] = [];

    const allowedTypes = ['Project', 'StatementOfWork', 'Organization'];

    if ((ancestor as any).texts && allowedTypes.some((at) => ancestor.type.includes(at))) {
      (ancestor as any).texts
        .filter((t: TextSet) => t.accessLevel!.id !== 'System')
        .forEach((a: TextSet) => {
          textSets.push({ textSet: a, space: ancestor } as TextSetSpace);
        });
    }

    if ((ancestor as unknown as IBaseHasParent).parent) {
      textSets = textSets.concat(this.getTextSetFromAncestor((ancestor as unknown as IBaseHasParent).parent));
    }

    return textSets;
  }

  public getTextSetFromPhase(phase: IBase, space: IBaseProject, master?: MasterProject): TextSetSpace[] {
    if (!phase) return [];

    if ((phase as any).texts && (phase as any).texts.length > 0) {
      return (phase as any).texts
        .filter((t: TextSet) => t.accessLevel!.id !== 'System')
        .map((a: TextSet) => {
          return { textSet: a, space: space, master: master, phase: phase } as TextSetSpace;
        });
    }

    return [];
  }
}
